import { useCallback } from 'react';

import { CategoryOpenMode } from '../../../models/category/category';
import {
  DictButtonFormControlViewModel,
  DictDateFormControlViewModel,
  DictionaryInputFormControlViewModel,
  DictMultilineFormControlViewModel,
} from '../../../services/form/view-model/FormControlViewModel';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getDictionaryFormControlInParams } from '../../../store/selectors/form';
import categoryActions from '../../../store/slices/category';
import { DictionaryEffectType } from '../../../store/slices/dictionary';

import { TFormControlConnectorProps } from './FormControlContainer';

type DictControlViewModel =
  | DictButtonFormControlViewModel
  | DictDateFormControlViewModel
  | DictionaryInputFormControlViewModel
  | DictMultilineFormControlViewModel;

interface DictOwnProps<
  T extends DictControlViewModel,
> extends TFormControlConnectorProps {
  control: T;
}

export const useDictionaryControl = <T extends DictControlViewModel>(
  props: DictOwnProps<T>
) => {
  const { control, formId } = props;
  const dispatch = useAppDispatch();

  const inParams = useAppSelector(state =>
    getDictionaryFormControlInParams(state, formId, control.name)
  );

  const onButtonClick = useCallback(() => {
    dispatch(
      categoryActions.openDisplayMode({
        category: control.category,
        displayMode: control.displayMode,
        ui: {
          mode: CategoryOpenMode.DICTIONARY,
          effect: {
            type: DictionaryEffectType.UPDATE_WITH_OUT_PARAMS,
            form: formId,
            field: control.name,
          },
          multiSelect:
            ('multiSelect' in control ? control.multiSelect : false) ?? false,
          fullHierarchy: control.fullHierarchy,
          hideTree: control.hideTree,
        },
        inParams,
      })
    );
  }, [dispatch, control, formId, inParams]);

  return onButtonClick;
};
